import { sliderResize } from './slider-resize'
const TABLET_WIDTH = 1024
const MOBILE_WIDTH = 768

const sliderOptions = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: MOBILE_WIDTH,
      settings: {
        slidesToShow: 1
      }
    }
  ]
}
const $slider = $('.js-slider-products-resize')

$(window)
  .on('load resize', function () {
    if ($slider.length) {
      sliderResize($slider, true, sliderOptions, false, false)
    }
  })
